module.exports = __webpack_public_path__ + "img/images.0a312284.png";